export const isSaleCard = (card: any) => {
    const hiddenInfo = card?.additionalInfo?.find(({key}: {key: string}) => key === 'isHidden');
    const {value: isHidden} = hiddenInfo || {};
    const isHiddenParam = hiddenInfo?.parameters?.isHidden
    return !!isHidden && !!isHiddenParam;
}export const isSaleCard = (card: any) => {
    const hiddenInfo = card?.additionalInfo?.find(({key}: {key: string}) => key === 'isHidden');
    const {value: isHidden} = hiddenInfo || {};
    const isHiddenParam = hiddenInfo?.parameters?.isHidden
    return !!isHidden && !!isHiddenParam;
}